import { useState } from 'react';
import { categories } from '../../../mocks/products';

interface Props {
  selectedCat: string;
  selectedSub: string;
  onSelectCat: (catId: string) => void;
  onSelectSub: (subId: string) => void;
}

export default function CategorySidebar({ selectedCat, selectedSub, onSelectCat, onSelectSub }: Props) {
  const [openCats, setOpenCats] = useState<string[]>(categories.map(c => c.id));
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleCat = (catId: string) => {
    setOpenCats(prev =>
      prev.includes(catId) ? prev.filter(id => id !== catId) : [...prev, catId]
    );
  };

  const SidebarContent = () => (
    <div className="flex flex-col gap-1">
      {/* All Products */}
      <button
        onClick={() => { onSelectCat('all'); onSelectSub('all'); }}
        className={`flex items-center gap-2 px-4 py-2.5 text-sm font-semibold cursor-pointer transition-colors whitespace-nowrap
          ${selectedCat === 'all' ? 'bg-[#1a73b5] text-white' : 'text-gray-700 hover:bg-[#f0f6ff] hover:text-[#1a73b5]'}`}
      >
        <i className="ri-list-unordered text-base" />
        全部產品
      </button>

      {categories.map(cat => (
        <div key={cat.id}>
          {/* Category Header */}
          <button
            onClick={() => { toggleCat(cat.id); onSelectCat(cat.id); onSelectSub('all'); }}
            className={`w-full flex items-center justify-between gap-2 px-4 py-2.5 text-sm font-semibold cursor-pointer transition-colors
              ${selectedCat === cat.id && selectedSub === 'all' ? 'bg-[#1a73b5] text-white' : 'text-gray-700 hover:bg-[#f0f6ff] hover:text-[#1a73b5]'}`}
          >
            <div className="flex items-center gap-2">
              <i className={`${cat.icon} text-base`} />
              <span className="text-left leading-snug">{cat.label}</span>
            </div>
            <i className={`ri-arrow-down-s-line transition-transform ${openCats.includes(cat.id) ? 'rotate-180' : ''}`} />
          </button>

          {/* Sub-categories */}
          {openCats.includes(cat.id) && (
            <div className="flex flex-col">
              {cat.subCategories.map(sub => (
                <button
                  key={sub.id}
                  onClick={() => { onSelectCat(cat.id); onSelectSub(sub.id); }}
                  className={`flex items-center gap-2 pl-10 pr-4 py-2 text-sm cursor-pointer transition-colors whitespace-nowrap
                    ${selectedCat === cat.id && selectedSub === sub.id
                      ? 'text-[#1a73b5] font-semibold bg-[#f0f6ff]'
                      : 'text-gray-500 hover:text-[#1a73b5] hover:bg-[#f0f6ff]'}`}
                >
                  <span className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${selectedCat === cat.id && selectedSub === sub.id ? 'bg-[#1a73b5]' : 'bg-gray-300'}`} />
                  {sub.label}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );

  return (
    <>
      {/* Desktop Sidebar */}
      <aside className="hidden lg:block w-56 flex-shrink-0">
        <div className="border border-gray-100 overflow-hidden">
          <div className="bg-[#1a2535] px-4 py-3 flex items-center gap-2">
            <i className="ri-apps-2-line text-[#4fc3f7] text-lg" />
            <span className="text-white text-sm font-bold tracking-widest uppercase">產品分類</span>
          </div>
          <SidebarContent />
        </div>
      </aside>

      {/* Mobile Filter Toggle */}
      <div className="lg:hidden mb-4">
        <button
          onClick={() => setMobileOpen(v => !v)}
          className="flex items-center gap-2 bg-[#1a73b5] text-white text-sm px-4 py-2.5 cursor-pointer whitespace-nowrap"
        >
          <i className="ri-filter-3-line" />
          產品分類篩選
          <i className={`ri-arrow-down-s-line transition-transform ${mobileOpen ? 'rotate-180' : ''}`} />
        </button>
        {mobileOpen && (
          <div className="border border-gray-100 border-t-0">
            <SidebarContent />
          </div>
        )}
      </div>
    </>
  );
}
